import React, { Suspense, lazy } from "react";
import { RenderLoadingSpinnerInImageTag } from "../../Helper";
import { useSelector } from "react-redux";

import ComponentHeader from "./ComponentHeader";
// import CreateDataBaseAndApiKeyComponent from "./Components/ChangeApiKeyComponent";
const CreateDataBaseAndApiKeyComponent = lazy(() =>
  import("./Components/CreateDataBaseAndApiKeyComponent")
);

export default function CreateDataBaseAndApiKey() {
  // * Start ***Enable Dark Mode Feature***
  const darkModeState = useSelector((state) => state.setMode).darkMode;
  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg, component_Key) {
    return (
      <Suspense
        key={component_Key}
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }
  return (
    <>
      {/* Profile Create database and api key */}
      <section className={` my-16`}>
        {returnComponentWithLazySetup(
          <ComponentHeader
            title="Database & Api key"
            details="Create database and change api key."
          />,
          "Database & api key page loading.."
        )}

        <section className={` flex flex-wrap justify-center items-center `}>
          <div
            className={` basis-full md:basis-2/3 lg:basis-2/4 xl:basis-2/5 flex flex-wrap`}
          >
            {/* Main card*/}
            <div className={` basis-full p-4`}>
              <div
                className={` relative py-9 px-5 space-y-6 shadow-xl rounded-3xl border overflow-hidden ${
                  darkModeState
                    ? " bg-[#001e2b] border-[#38b982] "
                    : " bg-white border-[#38b9813b]"
                }`}
              >
                {returnComponentWithLazySetup(
                  <CreateDataBaseAndApiKeyComponent apiKey="akjdbdj" />,
                  "Change Api key section loading.."
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
